export class Category {
  value: number = 12;
  constructor(public id: number, public label: string, public meta_category: number) {}
}